import * as React from 'react';
import styled from 'styled-components';

import { ANIMATION, BREAK_POINTS, COLOURS } from '../../consts/style';
import { Heading3, HeadingLink, headingLinkOnHoverMixin } from '../Text';
import { InlineSvg } from '../Svg';
import { IHelpSupports } from '../../models/content.interfaces';
import { DangerousHtml } from '../DangerousHtml';
import { Link } from '../Link';

import { isEmpty } from 'lodash';

const StyledSvg = styled(InlineSvg)`
  svg {
    fill: ${COLOURS.PRIMARY.ORANGE_LIGHT};
    height: 48px;
    margin-top: 8px;
    transition: transform ${ANIMATION.ICON.SPEED};
    @media (max-width: ${BREAK_POINTS.MAX.MD}) {
      height: 30px;
    }
  }
` as any;

const StyledCopy = styled.div`
  padding-top: 21px;
  h4 {
    @media (max-width: ${BREAK_POINTS.MAX.MD}) {
      margin-bottom: 0px;
    }
  }

  p {
    font-size: 14px;
    font-weight: normal;
    color: ${COLOURS.PRIMARY.GREY};
    line-height: 1.71;
    @media (max-width: ${BREAK_POINTS.MAX.MD}) {
      margin-top: 12px;
    }
  }

  @media (max-width: ${BREAK_POINTS.MAX.MD}) {
    margin-top: -15px;
    padding-left: 15px;
  }
`;

const StyledHelpItem = styled.article`
  display: block;
  box-sizing: border-box;
  padding: 20px 15px;
  width: 100%;

  > a {
    ${headingLinkOnHoverMixin};

    cursor: pointer;

    text-decoration: none;
    line-height: 1;

    &:visited {
      color: inherit;
    }

    @media (max-width: ${BREAK_POINTS.MAX.MD}) {
      display: flex;
    }
    &:hover {
      ${StyledSvg} > svg {
        transform: scale(${ANIMATION.ICON.SCALE});
      }
    }
  }

  @media (max-width: ${BREAK_POINTS.MAX.MD}) {
    padding: 0 0 2px;
    max-width: none;
    width: 100%;
  }
`;

export const HelpItem = ({ headline, bylineHtml, icon, link, target }) => (
  <StyledHelpItem data-comment="HelpItem">
    <Link
      title={headline}
      href={link}
      target={isEmpty(target) ? '_self' : target}
      data-id={`support-${headline}`}
      componentType="link"
    >
      {icon}
      <StyledCopy>
        <HeadingLink>{headline}</HeadingLink>
        <p>
          <DangerousHtml html={bylineHtml} />
        </p>
      </StyledCopy>
    </Link>
  </StyledHelpItem>
);

const HelpItemsList = styled.div`
  display: flex;
  padding: 0 15px;
  box-sizing: border-box;

  @media (max-width: ${BREAK_POINTS.MAX.MD}) {
    flex-wrap: wrap;
  }
`;

const HelpSupportContainer = styled.div`
  padding-top: 64px;
  padding-bottom: 32px;
  margin: 0px;

  @media (max-width: ${BREAK_POINTS.MAX.MD}) {
    padding-top: 32px;
    padding-bottom: 26px;
    margin: 0;
  }
`;

const HelpHeading = Heading3.extend`
  padding-left: 15px;
  padding-right: 15px;
  box-sizing: border-box;

  @media (min-width: 992px) {
    text-align: center;
  }
`;

export const HelpSupport = ({ items, mainHeading }: IHelpSupports) => {
  return (
    <HelpSupportContainer data-comment="HelpSupportContainer">
      <HelpHeading>{mainHeading}</HelpHeading>
      <HelpItemsList>
        {items.map((item) => (
          <HelpItem
            key={item.headline}
            headline={item.headline}
            bylineHtml={item.bylineHtml}
            icon={<StyledSvg html={item.iconSvg} />}
            link={item.buttonUrl}
            target={item.target}
          />
        ))}
      </HelpItemsList>
    </HelpSupportContainer>
  );
};
